<template>
  <Layout>
    <div class="is-size-7 p-md">
      <div class="has-text-centered" style="margin:auto;max-width:600px;">
        <GameTile :game="game" class="has-text-left" />
        <p class="is-size-5 has-text-primary">Game Game - играйте и се наслаждавайте на най-новите игри!</p>
        <div class="m-md">
          <span class="button is-primary is-size-3">Плати с мобилния оператор</span>
        </div>
        <p class="is-size-7 m-t-lg m-b-lg">
          Цената е 6.01 лв. за месец
        </p>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/GG'
import GameTile from '@/components/LangGG/GameTile'

export default {
  name: 'Home',
  components: {
    Layout,
    GameTile
  },
  data () {
    return {
      isMsisdn: true,
      msisdn: '0',
      carrier: '23001',
      game: {
        name: 'Speed Pool King',
        path: 'https://assets.gamega.me/avi/SpeedPoolKing_0304/index.html',
        icon: 'https://assets.gamega.me/avi/SpeedPoolKing_0304/sqricon.png',
        tags: [ 'Ability', 'Action', 'Maximum score' ],
        votes: 29,
        score: 3.7241379310344827,
        id: 111
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LangGG/BG/LPOtp.vue